// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ChartHistoryType } from './Utils/ChartConstants';
import { HistoryType } from '@shared/utils/History/HistoryType';
import { Periods } from '@shared/utils/History/TFInfo';
import { Resources } from '@shared/localizations/Resources';
export class TerceraChartActionState {
    constructor() {
        this.Visible = true;
        this.Enabled = true;
        this.Active = false;
        this.locKey = '';
        this.ToolTiplocKey = '';
        this.svgImage = '';
        this.details = null;
    }
    applyFrom(state) {
        this.Visible = state.Visible;
        this.Enabled = state.Enabled;
        this.Active = state.Active;
        this.locKey = state.locKey;
        this.ToolTiplocKey = state.ToolTiplocKey;
        this.details = state.details;
    }
    static GetHistoryTypeActionState(historyType, period, ins, currentHistoryType) {
        const res = new TerceraChartActionState();
        if (!ins)
            return res;
        // SourceTypes
        const lSourceTypes = ins.DataCache.GetAllowedHistoryTypesByPeriod(period);
        const isTick = period === Periods.TIC;
        switch (historyType.ChartDataType) {
            case ChartHistoryType.Default: {
                const def = ins.DefaultChartHistoryType;
                res.locKey =
                    Resources.getResource('chart.view.source0') +
                        ' (' +
                        Resources.getResource('chart.view.source' + (def === 1 && isTick ? 'BID/ASK' : def)) +
                        ')';
                break;
            }
            case ChartHistoryType.ByBid:
                res.locKey = 'chart.view.source' + HistoryType.BID;
                break;
            case ChartHistoryType.ByBidAsk:
                res.locKey = 'chart.view.sourceBID/ASK';
                break;
            case ChartHistoryType.ByTrades:
                res.locKey = 'chart.view.source' + HistoryType.LAST;
                break;
            case ChartHistoryType.ByASk:
                res.locKey = 'chart.view.source' + HistoryType.ASK;
                break;
        }
        res.Active = currentHistoryType === historyType.ChartDataType;
        // Visibility
        if (historyType.ChartDataType === ChartHistoryType.Default) {
            res.Visible = true;
        }
        else if (historyType.ChartDataType === ChartHistoryType.ByBid) {
            res.Visible = lSourceTypes.includes(historyType.HistoryType()) && !isTick;
        }
        else if (historyType.ChartDataType === ChartHistoryType.ByBidAsk) {
            res.Visible = lSourceTypes.includes(historyType.HistoryType()) && isTick;
        }
        else {
            res.Visible = lSourceTypes.includes(historyType.HistoryType());
        }
        return res;
    }
}
